<ng-container *transloco="let t">
  <div class="row" [formGroup]="editForm">
    <div class="col-6" formGroupName="config">

      <ng-container *ngIf="selectedId$ | async as id; else autocompleteTmpl">
        <span>{{id | procedureName | async}}</span>
        <a class="ml-2" (click)="unselect()">
          <mat-icon>clear</mat-icon>
        </a>
      </ng-container>

      <ng-template #autocompleteTmpl>
        <mat-form-field class="w-100" appearance="fill">
          <mat-label for="innerProcedureId">{{t('inner-procedure-edit.innerProcedureId')}}</mat-label>
          <input #autocompleteInput formControlName="innerProcedureId" matInput type="text" autocomplete="off"
            [matAutocomplete]="auto" (keyup)="search($any($event).target?.value)">
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="autoCompleteDisplayWithFn"
            (optionSelected)="select($event)">
            <mat-option *ngFor="let p of procedures$ | async" [value]="p">{{p.name}}</mat-option>
          </mat-autocomplete>
          <a matSuffix (click)="unselect(); autocompleteInput.value = ''" [hidden]="!autocompleteInput.value">
            <mat-icon matDatepickerToggleIcon>clear</mat-icon>
          </a>
        </mat-form-field>
      </ng-template>

    </div>
  </div>
</ng-container>
